<template>
  <div class="row documents" v-if="applicationDocuments.length > 0">
    <div class="col-md-12">
      <h4>Документы</h4>
      <div class="form-fieldhelp" style="right: 15px">
        <label>?</label>
        <div class="form-fieldhelp-text">
          <div>
            Прикрепите сканы документов в соответствующие для них разделы.
            <br/>Максимально допустимый размер файла - 2 МБ.
            <br/>Допустимые расширения файлов: png, jpg, pdf, gif, bmp, webp.
          </div>
        </div>
      </div>
    </div>
    <template v-for="(documentObj, documentKey) in applicationDocuments">
      <div :id="`application-document-block-${documentObj.document.id}`" :key="documentKey">
        <div class="col-md-12 col-sm-12 col-xs-12 panel-group" style="margin-bottom: 5px">
          <uppy-uploader
              v-model="application.documents[documentObj.document.short_name]"
              :dashboard-show-condition="isNew || isDuplicate || isDraft || isEdit"
              :document-comment="documentObj.comment"
              :document-key="`application-document-${documentObj.document.short_name}`"
              :document-name="documentObj.document.name"
              :documents-show-condition="isView"
              :document-need-expire = "documentObj.need_expire"
              :document-short-name="documentObj.document.short_name"
              :max-files-count="documentObj.document.max_file"
              :document-id="documentObj.document.id"
               entity-type="application"
              :entity-id="application.id"
              :files-request="requestApplicationFiles"
              :get-uuid="getUUID"
              :has-errors="blockHasErrors(documentObj.document.short_name)"
              :key="`application-${documentObj.document.short_name}`"
              :form="form"
              ref="uploader"
              @file-removed="onFileRemoved($event, documentObj.document.short_name)"
              @upload-success="onUploadSuccess($event, documentObj.document.short_name)"
          />
          <div class="error-text" v-html="blockErrors(documentObj.document.short_name)"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import applicationFormContextMixin from '../../mixins/applicationFormContextMixin'
import applicationFormMixin from '../../mixins/applicationFormMixin';
import RusUppy from '@uppy/locales/lib/ru_RU';
import UppyUploader from '../inputs/UppyUploader';
import { ApiClient } from '../../helpers/api-client/ApiClient';

RusUppy.strings.done = 'Назад'
RusUppy.strings.noDuplicates = "Невозможно добавить файл '%{fileName}', он уже существует."

export default {
  name: 'ApplicationDocumentsBlock',

  components: {
    UppyUploader
  },

  mixins: [
    applicationFormMixin,
    applicationFormContextMixin
  ],

  props: {
    application: {
      type: Object,
      required: true
    },

    applicationDocuments: {
      type: [Array],
      default: () => []
    },

    form: {
      type: Object,
      default: () => ({})
    }
  },

  data: function () {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      dashboardOptions: {
        browserBackButtonClose: false,
        doneButtonHandler: null,
        height: 320,
        inline: true,
        note: 'Изображения и pdf до 2Мб',
        proudlyDisplayPoweredByUppy: false,
        showRemoveButtonAfterComplete: true,
        width: '100%'
      }
    }
  },

  updated() {
    this.$refs?.uploader?.forEach((uppy) => {
      uppy.$forceUpdate()
    })
  },

  methods: {
    requestApplicationFiles(documentType) {
      if (this.isNew) {
        return this.requestApplicationFilesOnNew(documentType)
      }
    },

    async requestApplicationFilesOnNew (documentType) {
      await ApiClient.getLatestApplicationOrganizationDoc({
        organization_inn: this.form.organization.inn,
        document_type: documentType
      }).then((response) => {
        const responseData = response.data.data

        if (Array.isArray(responseData)) {
          return
        }

        this.$set(this.form.application.documents, documentType, responseData[documentType])
      })
    },

    blockHasErrors (field) {
      return this.hasError(this.errors.application, `application-document-block-${field}`)
    },

    blockErrors (field) {
      return this.getError(this.errors?.application, `application-document-block-${field}`)
    },

    async fileRemoved (uuid, ext) {
      await ApiClient.removeUploadedDocument({ uuid, ext })
    },

    getUUID (file) {
      return file.meta.uuid
    },

    onFileRemoved(file, docName) {
      this.fileRemoved(file.meta.uuid, file.name.split('.').pop().toLowerCase())
      this.removeApplicationFile(this.application, docName)
    },

    removeApplicationFile(application, docName) {
      if (application.documents[docName].length === 0) {
        delete application.documents[docName];
      }
    },

    onUploadSuccess(file, docName) {
      if (this.errors.application && this.errors.application[`application-document-block-${docName}`]) {
        this.$delete(this.errors.application, `application-document-block-${docName}`)
      }
    }
  }
}
</script>
